<template>
  <div :class="['dashboard-layout', `theme-${theme}`]" :data-bs-theme="theme === 'dark' ? 'dark' : 'light'"
    class="d-flex flex-column min-vh-100">

    <!-- Overlay for mobile when sidebar is open -->
    <div class="sidebar-overlay" id="sidebarOverlay" @click="closeSidebar"></div>

    <Header />

    <!-- Content area: flex row -->
    <div class="content-area d-flex flex-grow-1">

      <!-- Sidebar: fixed -->
      <Sidebar />

      <!-- Main + Right Sidebar wrapper -->
      <main id="main" class="main-wrapper d-flex flex-grow-1 flex-column">
        <!-- Slot content + right sidebar row -->
        <div class="content-row d-flex flex-grow-1">
          <!-- Main content area with proper width constraint -->
          <div class="content flex-grow-1" style="min-width: 0;">
            <slot />
          </div>
          <!-- Right sidebar, only if provided -->
          <aside v-if="$slots['right-sidebar']" class="right-sidebar">
            <slot name="right-sidebar" />
          </aside>
        </div>
      </main>

    </div>

    <Footer />

  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount } from 'vue'
import Sidebar from '../includes/AppSidebar.vue'
import Header from '../includes/AppHeader.vue'
import Footer from '../includes/AppFooter.vue'

import '@/assets/css/dashboard.css'
import { useTheme } from '@/composables/useTheme'
const { theme } = useTheme()

function closeSidebar() {
  const sidebar = document.getElementById('sidebar')
  const main = document.getElementById('main')
  const header = document.getElementById('header')
  const overlay = document.getElementById('sidebarOverlay')

  sidebar?.classList.remove('active')
  main?.classList.remove('shifted')
  header?.classList.remove('shifted')
  overlay?.classList.remove('active')
}

function handleMenuToggle() {
  const sidebar = document.getElementById('sidebar')
  const main = document.getElementById('main')
  const header = document.getElementById('header')
  const overlay = document.getElementById('sidebarOverlay')

  sidebar?.classList.toggle('active')
  main?.classList.toggle('shifted')
  header?.classList.toggle('shifted')
  overlay?.classList.toggle('active')
}

function handleResize() {
  // Close sidebar on desktop resize
  if (window.innerWidth >= 1080) {
    closeSidebar()
  }
}

onMounted(() => {
  const menuToggle = document.getElementById('menuToggle')

  if (menuToggle) {
    menuToggle.addEventListener('click', handleMenuToggle)
  }

  window.addEventListener('resize', handleResize)
})

onBeforeUnmount(() => {
  const menuToggle = document.getElementById('menuToggle')

  if (menuToggle) {
    menuToggle.removeEventListener('click', handleMenuToggle)
  }

  window.removeEventListener('resize', handleResize)
})
</script>

<style scoped>
.content {
  min-width: 0;
  overflow-x: auto;
}

.sidebar-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.sidebar-overlay.active {
  display: block;
  opacity: 1;
  pointer-events: auto;
}

/* Only show overlay on mobile/tablet */
@media (min-width: 1080px) {
  .sidebar-overlay {
    display: none !important;
  }
}
</style>